import * as React from "react"

import viewManager from "~/shared/util/viewManager"

const bannerStyle: React.CSSProperties = {
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 99999,
  background: "#f59e0b",
  color: "#000",
  padding: "6px 16px",
  fontSize: "13px",
  fontWeight: 600,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "12px",
}

const linkStyle: React.CSSProperties = {
  color: "#000",
  textDecoration: "underline",
  cursor: "pointer",
}

export default function PreviewBanner() {
  const previewId = viewManager.get("preview")
  if (!previewId) {
    return null
  }

  return (
    <div style={bannerStyle}>
      <span>Preview Mode</span>
      <a href="/_preview/exit" style={linkStyle}>
        Exit Preview
      </a>
    </div>
  )
}
